import {useEffect} from 'react'
import "./Rti.css"
import { ContentCard,Underline } from '../../widgets'
import { rti_data } from '../../constants/rti'

const asr= "https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/Departments/Ece/faculties/teachingfac/ASR.webp"


const Rti = () => {
    useEffect(() => {
        document.title = 'ACCET-RTI';
    }, []);
    return (
        <>
        <div className='rti_content'>
            <Underline heading="RTI"/>
            <div className='rti_cards'>
              {rti_data.map((item)=><ContentCard key={item.id} heading={item.program} pdf={item.pdf}/>)}
            </div>
        </div>
        <div className='rti_officer_holder'>
        <Underline heading="RTI Officer"/>
        <div className='rtiofficer'>
            <div className='rtiofficer_bg'>
                <img className='rtiofficer_img' src={asr} alt="Dr. A. Sivanantha Raja" />
                <div className='rtiofficer_des'>
                <p className="rtiofficer_name">Dr. A. Sivanantha Raja,</p>
                <p className="rtiofficer_designation">Professor & Head of the Department ECE</p>
                <p className='rtiofficer_mail'>sivanantharaja@accet.ac.in</p>
                </div>
            </div>
        </div>
        </div>
        </>
    )
}

export default Rti